module.exports = __webpack_public_path__ + "img/horizontal_5_1_7042.1eaac4f9.png";